import { useSection } from "../../lib/content";

export const Marquee = () => {
  const c = useSection("marquee");

  return (
    <div className="marquee-paused relative border-y border-slate-200 bg-slate-50 py-5 overflow-hidden">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {c.items.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span className="font-mono text-xs uppercase tracking-[0.22em] font-semibold text-slate-500 px-8">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#024AD8]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
